/* global G */

import { curry, setKey } from 'lib/util'

/**
 * Go Event Handler
 *
 * Gets back `count` amount of history entries.
 *
 * @param {number} count  number of entries in the history to go back
 * @param {Gaia.AppModule.Spec} module - app module
 * @param {Gaia.Component.Spec} component - action component
 * @param {Event} event - event
 * @returns {function(*): function(...[*]): Promise<*[]>}
 */
const go = async (count, module, component, event) => {
  setKey(null, G.UNDO, module[G.STATE][G.ACTION][G.STATE])
  await module[G.ADAPTER][G.ROUTER].go(count)
}

export default curry(go)
